// The account button's face (009 revision 6, FR-046; 010 revision 13, FR-093): the initials and, from 1024 px, the
// name and role, with the button's classes. Shared by the button drawn at start-up (ShellUserMenu.tsx) and the
// dropdown's own trigger (user-menu-dropdown.tsx), so the button does not change when the menu's code arrives.
import { initials } from '../components/Avatar';
import { Avatar, AvatarFallback } from '../components/ui/avatar';

/** The account button's classes. */
export const USER_MENU_TRIGGER =
  'flex min-h-control-touch min-w-11 cursor-pointer items-center justify-center gap-3 rounded-full text-ink lg:min-h-control lg:min-w-0';

/**
 * The button's content.
 * @param props the person's name and role label, and whether the name shows from 1024 px
 * @returns the name, role and initials
 */
export function UserMenuFace({
  name,
  roleLabel,
  showName,
}: {
  name: string;
  roleLabel: string;
  showName: boolean;
}) {
  return (
    <>
      {showName && (
        <span className="hidden min-w-0 flex-col items-end text-end lg:flex">
          <span className="max-w-48 truncate text-sm font-semibold">{name}</span>
          <span className="max-w-48 truncate text-xs text-ink-secondary">{roleLabel}</span>
        </span>
      )}
      <Avatar>
        <AvatarFallback>{initials(name)}</AvatarFallback>
      </Avatar>
    </>
  );
}
